import React, { useState } from "react";
import { Typography } from "@mui/material";
import CredentialsUrbano from "../../forms/CredentialsUrbano";
import {
  ICredentialsUrbano,
  ICredentialsUrbanoErrors,
  ICredentialsStep,
} from "../../../interfaces/configuration";
import ConfirmChangesCredentials from "../ConfirmChangesCredentials";
import { ERRORS_MESSAGES } from "../../../utils/constants";
import { validateInputs } from "../../../utils/inputValidations";
import { IValidation } from "../../../interfaces/form";
import GenericAlert from "../../GenericAlert";
import GenericForm from "../../GenericForm";
import CredentialsDimensions from "../../modals/CredentialsDimensions";

const {
  urbanoPasswordRequired,
  urbanoClientIdRequired,
  ivaOnlyNumbers,
  ivaRequired,
  widthGreatherThanZero,
  heightGreatherThanZero,
  depthGreatherThanZero,
  weightGreatherThanZero,
} = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "urbano_password",
    type: "required",
    message: urbanoPasswordRequired,
  },
  {
    id: "urbano_client_id",
    type: "required",
    message: urbanoClientIdRequired,
  },
  {
    id: "iva",
    type: "only-numbers",
    message: ivaOnlyNumbers,
  },
  {
    id: "iva",
    type: "required",
    message: ivaRequired,
  },
  {
    id: "height",
    type: "only-numbers",
    message: heightGreatherThanZero,
  },
  {
    id: "width",
    type: "only-numbers",
    message: widthGreatherThanZero,
  },
  {
    id: "depth",
    type: "only-numbers",
    message: depthGreatherThanZero,
  },
  {
    id: "weight",
    type: "only-numbers",
    message: weightGreatherThanZero,
  },
];

const UrbanoCredentials = ({
  handleCancel,
  alert,
  carrier,
  loading,
  handleSubmitCarriers,
}: ICredentialsStep) => {
  const [credentials, setCredentials] = useState({} as ICredentialsUrbano);
  const [errors, setErrors] = useState({} as ICredentialsUrbanoErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(credentials, formValidations);

    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleSubmitCarriers([
        {
          ...carrier,
          credentials,
        },
      ]);
    }
  };

  return (
    <>
      <Typography className="f-s-24 m-b-20">Credenciales de URBANO</Typography>
      {alert.showAlert && <GenericAlert alert={alert} />}
      <GenericForm onSubmit={handleSubmit}>
        <CredentialsUrbano
          values={credentials}
          setValues={setCredentials}
          errors={errors}
        />
        <CredentialsDimensions
          values={credentials}
          setValues={setCredentials}
          errors={errors}
        />
      </GenericForm>
      <ConfirmChangesCredentials
        onClose={handleCancel}
        handleSubmit={handleSubmit}
        disabled={loading}
        backText="Cambiar operador"
        confirmText="Finalizar"
      />
    </>
  );
};

export default UrbanoCredentials;
